import { render, staticRenderFns } from "./MediaModal.vue?vue&type=template&id=39d7aea6&scoped=true&"
import script from "./MediaModal.vue?vue&type=script&lang=ts&"
export * from "./MediaModal.vue?vue&type=script&lang=ts&"
import style0 from "./MediaModal.vue?vue&type=style&index=0&id=39d7aea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d7aea6",
  null
  
)

export default component.exports